<template lang="html">

  <article class="oferta-el">
    

    <div class="top row-start">
      <h4 class="codigo">[{{data.idoferta | withoutoferta}}]</h4>
      <h2 class="titulo">{{data.titulo}}</h2>
    </div>
    <div class="middle row-start">
      <h3 v-if="!!data.fecha" class="fecha">{{data.fecha}}</h3>
      <h3 v-if="!!data.provincia" class="localizacion">{{data.provincia}}</h3>
      <h3 v-if="!!data.idSectorOferta" class="sector">{{dominios.sectores[data.idSectorOferta]}}</h3>
      <h3 v-if="!!data.empresa" class="empresa">{{data.empresa}}</h3>
    </div>
    <p class="descripcion" v-html="data.descripcion"></p>

    <router-link :to="$t('enlaces.oferta')+'/'+data.urlAcceso" class="enlace-cover"></router-link>

  </article>

</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  export default {
    name: 'oferta',
    props : ['data'],
    computed:{
      ...mapGetters({
        dominios : 'getDominios'
      })
    },
    filters : {
      withoutoferta(value){
        return value.replace("oferta","");
      }
    }

  }
</script>


<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/parts/oferta-el.vue